export default [
    0, 4, 8, 10, 16, 20, 24, 28, 32, 40, 48, 64, 80, 96, 128, 256, 512,
    //
];
